import { motion } from "framer-motion";
import React from "react";
import TitlePages from "../../components/TitlePage";
import Galeria from "./Galeria";
import Parrafo from "./Parrafo";
import CTAsec from "../../components/CTAsec";

const QuienesSomos = ({ variants }) => {
  return (
    <>
      <motion.div
        className={"transition"}
        initial={{ x: 0 }}
        animate={{ x: "100%" }}
        exit={{ x: 0 }}
        transition={{
          transition: 3,
          type: "spring",
          stiffness: 200,
        }}
      />
      <div className="containerDiv">
        <TitlePages
          title={"Quiénes somos"}
          toptitle={"Nosotros"}
          variants={variants}
          expand
        />
        <Parrafo variants={variants} />
        <Galeria variants={variants} />
        <CTAsec href={"/contacto"} type="link" variants={variants} />
      </div>
    </>
  );
};

export default QuienesSomos;
